import React from "react";
import { PageHero, Section, FACILITIES } from "./_shared";
import { Building2, Wrench, Cpu, BookOpen, Users, Briefcase } from "lucide-react";

const ICONS = {
  "Modern Purpose-built Campus": Building2,
  "Trade Workshops": Wrench,
  "Spacious Computer Laboratory": Cpu,
  "Well-equipped Library": BookOpen,
  "Conference Hall": Users,
  "Employment & Self-Employment Cell": Briefcase,
};

export default function Facilities() {
  return (
    <div data-testid="mitcidco-facilities">
      <PageHero
        eyebrow="Campus &amp; Facilities"
        title="Purpose-built for hands-on training"
        sub="From dedicated trade workshops to a modern computer laboratory and a well-equipped library — every space is designed for practical, industry-oriented learning."
      />
      <Section>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {FACILITIES.map((f, i) => {
            const Icon = ICONS[f.title] || Building2;
            return (
              <div key={i} className="group bg-white border border-amber-100 hover:border-[#D4A017] hover:-translate-y-1 transition-all overflow-hidden" data-testid={`mitcidco-facility-${i}`}>
                <div className="h-32 relative overflow-hidden" style={{ background: `linear-gradient(135deg, ${i % 2 ? "#7C2D12" : "#D4A017"}, ${i % 2 ? "#9A3412" : "#B58007"})` }}>
                  <div className="absolute inset-0 flex items-center justify-center text-white/90">
                    <Icon size={48} strokeWidth={1.4} />
                  </div>
                  <div className="absolute top-3 right-3 text-white/80 font-mono text-xs">0{i + 1}</div>
                </div>
                <div className="p-5">
                  <div className="font-serif text-lg text-[#7C2D12] leading-tight">{f.title}</div>
                  <p className="mt-3 text-sm text-slate-700 leading-relaxed">{f.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </Section>
    </div>
  );
}
